import { useEffect } from "react";

import { useBxpWebStargateClient } from "@/libraries/bxp-web-stargate-client/src";

import { useFastshiftDispatch, useFastshiftSelector } from "../../../state";
import * as StateActions from "../../../state/actions";

// This hook is called in PageLayout to set up state for all domain-scoped routes
export const useLoadDomainScopedState = (
    customerDomainId: string | null
): void => {
    const stargateClient = useBxpWebStargateClient();
    const dispatch = useFastshiftDispatch();
    const customerDomain = useFastshiftSelector(
        (state) => state.customerDomain
    );

    useEffect(() => {
        // Fetch is not relevant to non-domain scoped pages
        if (!customerDomainId) return;

        // Don't refetch if domain-scoped state is already available
        if (customerDomain?.data?.customerDomainId === customerDomainId) return;

        // Clear any outdated domain-scoped data
        // For example - a partner selected a different customer domain
        if (customerDomain?.data) {
            dispatch(StateActions.clearAllCustomerDomainScopedState());
        }

        dispatch(
            StateActions.getCustomerDomain({
                stargateClient,
                customerDomainId
            })
        );
        dispatch(
            StateActions.getCustomerDomainEngagementDetails({
                stargateClient,
                customerDomainId
            })
        );
        // Add once available: retrieve domain-scoped move tickets

        // Only run effect when URL Parameter is updated
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerDomainId]);
};
